export interface TemplateImageDto {
  id: string;
  fileName: string;
  downloadUrl: string;
}

// Backend-enforced constraints (see TemplateImageFile on the backend).
// Mirrored here so the UI can validate before hitting the API and surface
// clear messages. Keep in sync with the backend if the limits change.
export const TEMPLATE_IMAGE_MAX_SIZE_BYTES = 5 * 1024 * 1024;

export const TEMPLATE_IMAGE_ACCEPT = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
};
